// extracted by mini-css-extract-plugin
export default {"inStockIndicator":"style--inStockIndicator--4fb434","critical":"style--critical--eb2168","runningLow":"style--runningLow--46030d","sufficient":"style--sufficient--563290"};